export const getEffectiveSalary = job => {
  const override = String(job?.salary_override || '').trim();
  return override || String(job?.salary || '').trim();
};
